import {NgModule} from '@angular/core';

import {AppMaterialModule} from '../app.material.module';
import {MatSnackBarModule, MatStepperModule} from '@angular/material';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {CommonModule} from '@angular/common';
import {TableComponent} from './components/table/table.component';
import {RouterModule} from '@angular/router';
import { OkCancelDialogComponent } from './components/ok-cancel-dialog/ok-cancel-dialog.component';
import { AuditTitleComponent } from './components/audit-title/audit-title.component';
import { SidStepperComponent } from './sid-stepper/sid-stepper.component';
import { SidTitleComponent } from './components/sid-title/sid-title.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    TableComponent,
    OkCancelDialogComponent,
    AuditTitleComponent,
    SidStepperComponent,
    SidTitleComponent,
  ],
  imports: [
    AppMaterialModule,
    CommonModule,
    RouterModule,
    MatSnackBarModule,
    MatStepperModule,
    ReactiveFormsModule,
  ],
  exports: [
    AppMaterialModule,
    BreadcrumbComponent,
    CommonModule,
    TableComponent,
    OkCancelDialogComponent,
    AuditTitleComponent,
    SidStepperComponent,
    SidTitleComponent,
  ],
  entryComponents: [
    OkCancelDialogComponent,
  ],
  providers: [],
})

export class SharedModule {}
